module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1191-retro.f0827607.jpg";